import React from 'react'
import AdminPage from 'pages/app/AdminPage'
import { Translator } from '@morningtrain/react-translations'
import * as UI from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Collection, ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import * as Filters from 'support/filters'
import * as Accordion from 'support/utilities/accordions'
import * as Displays from 'support/displays'
import EditableAvatar from 'pages/app/coworkers/EditableAvatar'

export default function Overview () {
  return (
    <AdminPage>
      <Translator namespace='coworkers'>
        <Collection resourceName='coworkers'>
          <UI.PageHeader title={<TranslatedTitle name='titles.overview' />}>
            <Filters.DepartmentFilter />
          </UI.PageHeader>
          <Accordion.Accordion>
            <ForEachModel>
              <Accordion.ModelItem
                transparent
                modelName='key'
                defaultOpen
                title={(
                  <UI.SecondaryHeading>
                    <Displays.Text name='key' />
                  </UI.SecondaryHeading>
                )}
              >
                <ValueToCollection name='collection'>
                  <UI.VerticalList className='border-t'>
                    <ForEachModel>
                      <UI.SpaceBetween className='py-6 m-0'>
                        <div className='w-2/5'>
                          <UI.EmployeeInfo
                            large
                            avatar={<EditableAvatar />}
                            title={(
                              <UI.Text size='xl'>
                                <Displays.Text name='name' />
                              </UI.Text>
                            )}
                            text={(
                              <UI.Text>
                                <Displays.Text name='employment_type_name' />
                                <span> - </span>
                                <Displays.Text name='department_name' />
                              </UI.Text>
                            )}
                          />
                        </div>
                        <div className='w-2/5'>
                          <div className='flex flex-col'>
                            <UI.Text color='gray'>
                              <Displays.Email name='email' />
                            </UI.Text>
                            <UI.Text color='gray'>
                              <Displays.Phone name='phone' />
                            </UI.Text>
                          </div>
                        </div>
                        <div className='w-1/5 flex justify-end'>
                          <Displays.Badges bigger />
                        </div>
                      </UI.SpaceBetween>
                    </ForEachModel>
                  </UI.VerticalList>
                </ValueToCollection>
              </Accordion.ModelItem>
            </ForEachModel>
          </Accordion.Accordion>
        </Collection>
      </Translator>
    </AdminPage>
  )
}
